/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-05-03",
    versionChannel: "nightly",
    buildDate: "2024-05-03T00:06:01.109Z",
    commitHash: "181ddd7429ea8d839e35291c68f13917b16d2e3a",
};
